export default {
    listMailError: [],
    infoDB: {}
  }